<template>
  <!-- 写作 -->
  <div class="Writing">
    <div v-if="!data.answered">
      <div class="question">
        <div class="title">
          <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
          <span class="span" v-if="data.rule?data.rule.subTitle:false">{{data.rule.subTitle}}</span>
        </div>
        <!-- <div class="text" v-for="o in data.questionDes?JSON.parse(data.questionDes):[]" :key="JSON.stringify(o)" v-text="o.txt">
        </div> -->
        <pre v-if="data.questionDes">{{JSON.parse(data.questionDes)[0].txt}}</pre>
      </div>
      <div class="btn bold cursor" @click="toPage" v-if="$i18n.locale === 'en'">Enter Test</div>
      <div class="btn bold cursor" @click="toPage" v-else>进入写作</div>
    </div>
    <div v-else>
      <div class="question">
        <div class="title">
          <strong class="bold"><span class="required" v-if="data.rule ? (data.rule.isNecessary ? 1 : 0) : 0">*</span>{{data.questionTitle}}</strong>
          <span class="span" v-if="data.rule?data.rule.subTitle:false">{{data.rule.subTitle}}</span>
        </div>
        <!-- <div class="text" v-for="o in data.questionDes?JSON.parse(data.questionDes):[]" :key="JSON.stringify(o)" v-text="o.txt">
        </div> -->
        <pre v-if="data.questionDes">{{JSON.parse(data.questionDes)[0].txt}}</pre>
        <div class="answer_btn cursor" @click="answerBtn">
          <div class="answer_btn_title ellipsis" :title="JSON.parse(data.answered).title">{{JSON.parse(data.answered).title}}</div>
          <div class="answer_btn_icon blpc">&#xe6c5;</div>
        </div>
      </div>
    </div>
    <!-- 答案隐藏文字id -->
    <div class="answerObj none">{{answerObj}}</div>
    <div class="isNecessary none">{{data.rule ? (data.rule.isNecessary ? 1 : 0) : 0}}</div>
    <div v-if="data.rule.cameraMandatory === 1 && !data.answered" class="dpn" >
      <Video :isNeedShoot="false" @canGo="dealBtn" ref="videocontent" />
    </div>
  </div>
</template>

<script>

import Video from '@public/video'
import { mapState } from 'vuex'

export default {
  components: {
    Video
  },
  props: {
    data: Object,
    disabledBol: Boolean
  },
  name: 'BlInput',
  inject: ['dataId3'],
  computed: mapState({
    nowDate: state => state.common.nowDate,    // 当前时间
    subHeaderInfo: state => state.common.subHeaderInfo,
    answerObj () {
      return ''
    }
  }),
  data () {
    return {
      input: '',
      otherList: [],
      canDoExam: false
    }
  },
  methods: {
    // 查看作文
    answerBtn () {
      let url = window.location.href.split('/#/')[0] + '/#'
      url = url + `/WritingTaskLook?questionId=${this.data.questionId}&taskRelationId=${this.$route.query.taskRelationId}`
      window.open(url)
      // this.$router.push({
      //   path: '/WritingTaskLook',
      //   query: {
      //     ...this.$route.query,
      //     questionId: this.data.questionId
      //   }
      // })
    },
    // 如果需要监控，处理按钮
    dealBtn () {
      this.$refs.videocontent.closeVideo()
      this.canDoExam = true
    },
    // 前去编辑
    toPage () {
      if (this.data.rule.cameraMandatory === 1 && !this.canDoExam) {
        // this.$message.warn('请确认开启摄像头')
        this.$_Alter({
          data: {
            text: this.$t('bloomTest00083'),
            yesTxt: this.$t('bloomTest00018'),
            title: '',
            click: () => {}
          }
        })
        return
      }
      // 放倒计时
      let extraJson = this.subHeaderInfo.extraJson
      if (extraJson) {
        let obj = JSON.parse(this.subHeaderInfo.extraJson)
        if (obj.countdownData) {
          this.$utils.cache(`WritingTask${this.$route.query.taskRelationId}`, JSON.stringify(obj.countdownData), obj.countdownData.endTime)
        } else {
          this.$utils.cache(`WritingTask${this.$route.query.taskRelationId}`, null)
        }
      }
      let writingData = {
        taskRelationId: this.$route.query.taskRelationId,
        taskGroupType: this.dataId3.subHeaderInfo.taskGroupType,
        taskType: this.dataId3.subHeaderInfo.taskType,
        taskTitle: this.dataId3.subHeaderInfo.taskTitle,
        topicId: this.dataId3.subHeaderInfo.topicId,
        topicType: this.dataId3.subHeaderInfo.topicType,
        contestEn: this.dataId3.contestData.nameEn,
        seasonId: this.$utils.cache('seasonId'),
        curriculaId: this.dataId3.curriculaId
      }
      this.$utils.cache(`writingData${this.data.questionId}`, JSON.stringify(writingData))
      this.$router.push({
        path: '/WritingTask',
        query: {
          ...this.$route.query,
          questionId: this.data.questionId
        }
      })
    },
    // 初始化
    init () {
    }
  },
  mounted () {
    // this.$i18n.locale = 'en'
  },
  created () {
    this.init()
  },
  beforeDestroy () {
    // this.$i18n.locale = 'zh'
  }
}
</script>

<style lang="scss" scoped>
.Writing{
  margin-top: 24px;
  .question{
    font-size: 16px;
    .title{
      color: #303133;
      .span{
        color: #909399;
        font-size: 12px;
      }
    }
    pre{
      // font-size: 14px;
      // line-height: 19px;
      // font-family: MicrosoftYaHei;
      margin-top: 8px;
      color: #606266;
      font-size: 12px;
      line-height: 20px;
      word-break: break-word;
      white-space: pre-wrap;
    }
  }
  .btn{
    border: 1px solid #296BFF;
    border-radius: 24.5px;
    line-height: 38px;
    width: 120px;
    text-align: center;
    color: #296BFF;
    margin-top: 32px;
    &.disabled {
      color: #bcbec2;
      background-color: #f4f4f5;
      border-color: #e9e9eb;
      cursor: not-allowed;
    }
  }
  .answer_btn{
    background: #EDF1FB;
    border-radius: 4px;
    color: #296BFF;
    line-height: 20px;
    padding: 10px 16px;
    width: 236px;
    box-sizing: border-box;
    margin-top: 32px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .answer_btn_icon{
      font-size: 22px;
    }
  }
  .other{
    margin-top: 32px;
    .other_title, .other_item{
      font-size: 14px;
      line-height: 20px;
      span{
        margin-left: 16px;
        color: #296BFF;
      }
    }
    .other_title{
      margin-bottom: 16px;
    }
    .other_border{
      border-top: 1px solid #EBEEF5;
      margin-top: 32px;
    }
    .other_item_no{
      color: #909399;
      font-size: 12px;
      line-height: 17px;
    }
  }
  .dpn {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/module/topic/public/writing-box.vue